import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AvisosItem } from '../types/avisos.types';

@Injectable({
    providedIn: 'root'
})

export class AvisosService {

    public Data: AvisosItem[];
    public Banner: AvisosItem[];

    constructor(
        private http: HttpClient
    ) { }

    public CargarAvisos() {
        this.getAvisos().subscribe(data => {
            this.Data = data;
            this.IterarAvisos();
        });
    }

    public CrearAviso(Avisos) {
        const Existe = this.Data.filter(x => x.Aviso === Avisos.Aviso);

        if (Existe.length > 0) {
            return;
        }

        this.Data.push(Avisos);
        this.IterarAvisos();
    }

    private IterarAvisos() {
        this.Banner = this.Data.filter(x => x.Prioridad === 1);
        if (this.Banner.length === 0) {
            this.Banner = this.Data.filter(x => x.Prioridad === 2);
            if (this.Banner.length === 0) {
                this.Banner = this.Data.filter(x => x.Prioridad === 3);
            }
        }
    }

    public BorrarAviso(id: number) {
        this.Data = this.Data.filter(x => x.CodAviso !== id);
        this.IterarAvisos();
    }

    private getAvisos() {
        return this.http.get<AvisosItem[]>(
            `${environment.API_URL}/Avisos/`
        );
    }
}
